module.exports = __webpack_public_path__ + "static/music-republicain-4-58d3dd9f5e9054d268fec288e0805fcb.jpg";